import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { hasActivePeriodicPurchaseInstructions } from "web_myplann/Portfolio/Helpers/activePurchaseInstructions";

const calculatePaidAll = (baseData: PortfolioDetailResponseDTO) =>
	baseData.tools.reduce((acc, tool) => acc + tool.monthlyPayment, 0);

interface GetPaidAllLogicParams {
	baseData: PortfolioDetailResponseDTO;
	customPaidAllValue?: number;
}

interface GetPaidAllLogicReturn {
	paidAllValue: number;
	hasActivePurchases: boolean;
	shouldShowPaidAll: boolean;
}

export const getPaidAllLogic = ({
	baseData,
	customPaidAllValue,
}: GetPaidAllLogicParams): GetPaidAllLogicReturn => {
	const paidAllValue = customPaidAllValue ?? calculatePaidAll(baseData);
	const hasActivePurchases = hasActivePeriodicPurchaseInstructions(baseData);
	const shouldShowPaidAll = hasActivePurchases && paidAllValue > 0;

	return {
		paidAllValue,
		hasActivePurchases,
		shouldShowPaidAll,
	};
};
